import { useMutation } from "@tanstack/react-query";
import { createOrgStructureAssignment as apiCreate } from "../../api/apiOrgStructureAssignments";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateOrgStructureAssignment() {
    const navigate = useNavigate(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: createAssignment, isPending, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/org-structure-assignments'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { isPending, error, createAssignment };
}
